<template lang="pug">
    .intro

        .intro__share
            Share

        .intro__logo

            a.intro__logo--sf(
                href='https://secretmag.ru',
                @click='logoClick("secret firmy")',
                target='_blank',
                rel='noopener'
                )

                svg
                    use(
                        xlink:href='#sflogo'
                    )

            a.intro__logo--sb(
                href='https://www.sberbank.ru/ru/s_m_business?utm_source=secretmag.ru&utm_medium=cpm&utm_campaign=bankingservice_specialproject_corporate_logo_dec-2019 (https://www.sberbank.ru/ru/s_m_business?utm_source=secretmag.ru&utm_medium=cpm&utm_campaign=bankingservice_specialproject_corporate_logo_dec-2019)',
                @click='logoClick("sberbank")',
                target='_blank',
                rel='noopener'
                )

                svg
                    use(
                        xlink:href='#sberlogo'
                    )

        Corners

        Follow(
            :text='"Читать о сервисах"',
            :nextClick='true',
            v-on:clicknexttrigger='$emit("clicknexttrigger")'
            )

        .intro__wrapper

            .intro__heading
                p(
                    v-html='heading'
                    )

            svg.intro__image
                use(
                    xlink:href='#introsvg'
                )
            
            svg.intro__image--mobile
                use(
                    xlink:href='#mainmobile'
                )
            


</template>

<script>
const Follow = () => import('@/components/Follow.vue');
const Corners = () => import('@/components/Corners.vue');
const Share = () => import('@/components/Share.vue');

export default {
    name: 'Intro',

    components: {
        Follow,
        Corners,
        Share
    },

    props: {
        heading: String
    },

    methods: {
        logoClick(logoName) {
            this.$analytics.sendEvent({
                event: 'eventTracking',
                category: 'Button',
                action: 'click',
                label: `Logo ${logoName} clicked`
            });
        }
    }
};
</script>

<style lang="scss">
@import '../assets/css/vars.scss';
@import '../assets/css/corners.scss';

.intro {
    --theme: var(--color-green);
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    padding: calc(var(--block-width) * 0.5) 0;
    height: 100vh;

    @media (--viewport-laptop) {
        padding: 10vh 0;
    }

    @media (--viewport-tablet) {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: stretch;
        padding: 0 0 13vh 0;
        height: calc(100vh - 80px);
    }

    &__logo {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        padding: calc(var(--block-height) * 2);
        padding-bottom: 20px;

        @media (--viewport-tablet) {
            padding: 20px;
            padding-bottom: 0;
            position: relative;
            order: 1;
        }

        &--sf,
        &--sb {
            cursor: pointer;
            pointer-events: all;
        }

        &--sf {
            svg {
                width: 100px;
                height: 50px;

                @media (--viewport-tablet) {
                    width: 25vw;
                }
            }
        }

        &--sb {
            svg {
                width: 150px;
                height: 50px;

                @media (--viewport-tablet) {
                    width: 35vw;
                }
            }
        }
    }

    &__share {
        position: absolute;
        left: 0;
        top: 0;
        height: 100vh;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-end;

        @media (--viewport-tablet) {
            position: relative;
            order: 3;
            width: 100%;
            height: auto;
        }

        .share {
            &__inner {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                padding-left: calc(var(--block-height) * 2);
                padding-bottom: calc(var(--block-height) * 2);

                @media (--viewport-tablet) {
                    flex-direction: row;
                    padding: 0;
                }

                span {
                    margin-top: 20px;
                    background: var(--color-green);
                    border-radius: 50%;

                    @media (--viewport-tablet) {
                        margin: 0 20px;
                    }

                    svg {
                        fill: white;
                        width: 20px;
                        height: 20px;
                    }
                }
            }
        }
    }

    &__wrapper {
        position: relative;
        margin: 0 auto;
        max-width: var(--content-width);
        padding: 0 100px;
        width: 100%;
        text-align: center;

        @media (--viewport-laptop) {
            width: calc(100vw - 80px);
            padding: 0 40px;
            box-sizing: border-box;
            margin: 0;
        }

        @media (--viewport-tablet) {
            width: 100%;
            padding: 8vw 20px;
            text-align: center;
            order: 2;
        }
    }

    &__heading {
        position: absolute;
        top: calc(var(--vh) * 13.5);
        width: 100%;
        left: 0;
        font-size: 6vh;
        font-size: calc(var(--vh) * 4);
        text-align: left;
        line-height: 1;
        height: calc(var(--vh) * 23.5);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        @media (--viewport-laptop) {
            font-size: calc(var(--vh) * 3.5);
            top: calc(var(--vh) * 12.2);
            height: calc(var(--vh) * 20);
        }

        @media (--viewport-tablet) {
            display: none;
        }

        p {
            display: inline-block;
            max-width: 1000px;
            max-width: calc(var(--vh) * 144);
            padding-right: calc(var(--vh) * 35);

            @media (--viewport-laptop) {
                max-width: calc(var(--vh) * 110);
            }
        }
    }

    &__image {
        // width: 958px;
        // height: 687px;
        height: 80vh;
        height: calc(var(--vh) * 80);
        width: calc(var(--vh) * 80 * (958 / 687));

        @media (--viewport-laptop) {
            height: calc(var(--vh) * 70);
            width: calc(var(--vh) * 70 * (958 / 687));
        }

        @media (--viewport-tablet) {
            display: none;
        }

        &--mobile {
            display: none;

            @media (--viewport-tablet) {
                display: inline-block;
                width: 60vw;
                height: calc(60vw * (375 / 299));
            }
        }
    }
}
</style>
